import axiosWcaInstance from "./axios.wcaInstance";

export const API_GET_ALL_METADATA = async (page = 0, limit = 10) => {
  try {
    const response = await axiosWcaInstance.get("/metadata", {
      params: {
        page,
        limit,
      },
    });
    // Return the data payload from the response
    return response.data;
  } catch (error) {
    // Log the detailed error for debugging
    console.error(
      "Error fetching all metadata:",
      error.response?.data || error.message
    );
    // Throw a user-friendly error to be handled by the calling component
    throw new Error(
      error.response?.data?.message || "Failed to fetch metadata."
    );
  }
};
